module.exports = __webpack_public_path__ + "img/logo-sonphat.26658178.png";